<template>
  <v-main>
    <NavMenu :fromLogin="true" />
    <div class="background-image" id="offerPage">
      <div>
        <div
          fluid
          class="mt-0 pt-16 flex justify-center items-center align-center"
          style="flex-grow: 1; height: 100%"
        >
          <v-row justify="center" style="margin: 0; padding-top: 5%">
            <!-- Sol bilgi kolonu: lg'de form altına kayar, xl'de solda 50% -->
            <v-col
              cols="12"
              lg="4"
              class="flex-column px-6 px-lg-12 pt-10 pt-lg-16"
            >
              <p
                class="white--text font-weight-regular text-h4 text-sm-h3 text-xl-h2 mb-0 text-center text-md-left"
                style="line-height: 1.2"
              >
                {{ $t('messages.createOfferFormInfoTextTitle') }}
                <span class="font-weight-black font-italic">AlGönder </span>
              </p>

              <hr style="width: 20%; border: 3px solid red; margin: 4% 0" />

              <p
                class="white--text font-weight-regular text-sm-h6 text-xl-h5 mb-0 text-center text-md-left"
                style="line-height: 1.5"
              >
                {{ $t('messages.createOfferFormInfoTextDescription') }}
              </p>
              <br />
              <p
                class="white--text font-weight-regular text-sm-h6 text-xl-h5 mb-0 text-center text-md-left"
                style="line-height: 1.5"
              >
                {{ $t('messages.integrationText') }}
              </p>
              <br />
              <p
                class="white--text font-weight-regular text-sm-h7 text-xl-h6 mb-0 text-center text-md-left"
                style="line-height: 1.25"
              >
                {{ $t('messages.etsyText') }}
              </p>
            </v-col>

            <!-- Sağ form kolonu: lg'de üstte ~83%, xl'de sağda 50% -->
            <v-col cols="12" lg="8" class="pt-10 pt-lg-16">
              <CreateOfferForm />
            </v-col>
          </v-row>
          <!-- <v-row class="flex justify-center">
            <v-col
              :cols="getColumns()"
              class="pl-sm-4 pl-md-8 pl-lg-12 pl-xl-16"
            >
            
            </v-col>
            <v-col cols="6"></v-col>
          </v-row> -->
        </div>
      </div>
    </div>
  </v-main>
</template>
<script>
import NavMenu from '../components/NavMenu.vue';
import FormElement from '../components/FormElement.vue';
import Seaway from '../views/OfferScreens/Seaway.vue';
import Airline from '../views/OfferScreens/Airline.vue';
import Roadway from '../views/OfferScreens/Roadway.vue';
import Railway from '../views/OfferScreens/Railway.vue';
import CreateOfferForm from './OfferScreens/CreateOfferForm.vue';

export default {
  data() {
    return {
      // List
      transferTypes: [
        {
          Id: 1,
          Name: 'Kargo Taşıma',
        },
        {
          Id: 2,
          Name: 'Express Taşıma',
        },
      ],
      // Data

      // States
      transferType: 1,
      shipmentType: 1,
      pageLoading: false,
      creatingOffer: false,
    };
  },
  components: {
    NavMenu,
    FormElement,
    Seaway,
    Airline,
    Roadway,
    Railway,
    CreateOfferForm,
  },
  mounted() {
    this.setup();
  },
  computed: {
    formItems() {
      return this.shipmentTypes.find((item) => item.Id === this.shipmentType)
        .formItems;
    },
    shipmentTypes() {
      return [
        {
          Id: 1,
          Name: 'Deniz Yolu',
          Shipments: [1],
          Icon: 'mdi-ferry',
        },
        {
          Id: 2,
          Name: 'Hava Yolu',
          Shipments: [1, 2],
          Icon: 'mdi-airplane',
        },
        {
          Id: 3,
          Name: 'Kara Yolu',
          Shipments: [1],
          Icon: 'mdi-truck',
        },
        {
          Id: 4,
          Name: 'Demir Yolu',
          Shipments: [1],
          Icon: 'mdi-train',
        },
      ];
    },
  },
  watch: {},
  methods: {
    getColumns() {
      if (this.$vuetify.breakpoint.xl) {
        return 4;
      } else {
        return 12;
      }
    },
    getFormColumns() {
      if (this.$vuetify.breakpoint.xl) {
        return 8;
      } else {
        return 12;
      }
    },
    setup() {},
    /**
     * Resetting forms' validation.
     */
    async resetForm() {
      this.item = {};
      this.$refs.observer.reset();
      this.setup();
    },

    /**
     * This will trigger a function on service error.
     * @param {Function} special
     * @param {*} error
     */
    onServiceError(error, special = null) {
      if (special) {
        special(error);
      } else {
        window.showError(error);
        this.pageLoading = false;
        this.$store.state.loadingStatus = false;
      }
    },

    /**
     * Reset all models in View.
     */
    resetAllModels() {
      this.resetForm();
    },
  },
};
</script>
<style>
#offerPage {
  background: url('../images/1.jpg') no-repeat;
  animation: zoomIn 0.75s ease-out;
}

@keyframes zoomIn {
  from {
    transform: scale(1.075);
    opacity: 0.75;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
